import React from "react";
import './style.css';

export const showSuccessMessage = (success) => (
  <div className="alert alert-success">{success}</div>
);

export const showErrorMessage = (error) => (
  <div className="alert alert-danger">{error}</div>
);
